import { Monitor, Plus, RefreshCw, Smartphone, Target, ArrowLeftRight, TrendingUp } from "lucide-react";
import { Reveal } from "./motion";
import { PhoneFrame, BrowserBudgeAI } from "./devices";

const BULLETS = [
  { icon: Monitor, t: "Web — the full picture: money flow, budgets, reports" },
  { icon: Smartphone, t: "Mobile app (coming soon): quick capture, goals and net worth at a tap" },
  { icon: RefreshCw, t: "One account for web now, and for the mobile app when it launches" },
];

const QUICK = [
  { icon: Plus, l: "Add" },
  { icon: ArrowLeftRight, l: "Move" },
  { icon: Target, l: "Goals" },
  { icon: TrendingUp, l: "Stats" },
];

function PhoneHome() {
  return (
    <PhoneFrame className="w-[240px]">
      <div className="flex flex-1 flex-col gap-3 p-3">
        <div>
          <div className="text-[11px] font-medium text-muted-foreground">Good morning</div>
          <div className="text-lg font-extrabold tracking-tight text-foreground">Welcome back</div>
        </div>
        <div className="rounded-2xl p-4 text-white" style={{ background: "var(--gradient-primary)" }}>
          <div className="text-[11px] font-semibold text-white/85">Total net worth</div>
          <div className="text-[26px] font-extrabold tracking-tight">€48,250</div>
          <div className="mt-2 flex gap-4 text-[10px]">
            <div><div className="text-white/80">Income</div><div className="text-[13px] font-bold">€5,120</div></div>
            <div><div className="text-white/80">Spent</div><div className="text-[13px] font-bold">€3,880</div></div>
            <div><div className="text-white/80">Saved</div><div className="text-[13px] font-bold">24%</div></div>
          </div>
        </div>
        <div className="flex gap-2">
          {QUICK.map((q) => (
            <div key={q.l} className="flex flex-1 flex-col items-center gap-1.5 rounded-xl border border-border bg-card py-2.5">
              <q.icon className="h-4 w-4 text-primary-text" />
              <span className="text-[10px] font-bold text-muted-foreground">{q.l}</span>
            </div>
          ))}
        </div>
        <div className="rounded-2xl border border-border bg-card p-3">
          <div className="text-[13px] font-extrabold text-foreground">Emergency fund</div>
          <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-muted">
            <div className="h-full w-[64%] rounded-full bg-primary" />
          </div>
          <div className="mt-1.5 text-[11px] text-muted-foreground">€3,200 of €5,000</div>
        </div>
      </div>
    </PhoneFrame>
  );
}

export function WebMobileSection() {
  return (
    <section id="apps" className="bg-background">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 py-24 lg:grid-cols-2 lg:px-10">
        <div>
          <Reveal>
            <span className="text-sm font-bold uppercase tracking-widest text-primary-text">Web now, mobile app soon</span>
            <h2 className="mt-4 text-4xl font-extrabold leading-tight tracking-tight text-foreground">
              On your desk, and in your pocket.{" "}
              <span className="ml-1 inline-flex translate-y-[-0.35em] items-center rounded-full bg-primary/10 px-3 py-1 align-middle text-xs font-bold uppercase tracking-widest text-primary-text">
                Coming soon
              </span>
            </h2>
            <p className="mt-5 max-w-lg text-lg leading-relaxed text-muted-foreground">
              Set things up and study the money-flow view on the web. The mobile app is coming soon.
              Until then, Budge works in your phone's browser with the same account and the same data.
            </p>
          </Reveal>
          <ul className="mt-8 space-y-4">
            {BULLETS.map((b, i) => (
              <Reveal key={b.t} delay={i * 0.06}>
                <li className="flex items-center gap-3">
                  <span className="grid h-8 w-8 place-items-center rounded-lg bg-primary/10">
                    <b.icon className="h-4 w-4 text-primary-text" />
                  </span>
                  <span className="text-[15px] font-medium text-foreground">{b.t}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>

        <Reveal delay={0.12} y={32}>
          <div className="relative mx-auto flex max-w-xl items-center justify-center">
            <div className="hidden w-full sm:block">
              <BrowserBudgeAI />
            </div>
            <div className="sm:absolute sm:-right-2 sm:-bottom-8">
              <PhoneHome />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
